import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as DropdownIcon } from 'src/Images/icons/common/dropdown.svg';
import getColorCode from 'src/utils/GetThemeColor';

export default function AccordionCreateView({ createLeadFormComponents }) {
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const [openSections, setOpenSections] = useState({ 0: true }); // stores sections that are open in the accordion. example: {0: true, 1: false, 2: false}

  const toggleAccordionSections = (index) => {
    setOpenSections((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div className="div-flex-column rg-20">
      {createLeadFormComponents.map((section, index) => (
        <div className="div-flex-column" key={section.id}>
          <div
            className={`theme-accordian-title-${themeColor} div-space-between div-align-center`}
            data-testid={`accordion-header-${index}`}
            onClick={() => toggleAccordionSections(index)}
            role="button"
            tabIndex="0"
          >
            <div className="div-flex-row div-align-center cg-5">
              <span
                className={`
                text-sm text-semi-bold ${section.indicator ? 'pulse-text' : ''}`}
              >
                {section.title}
              </span>
            </div>
            <div className={openSections[index] ? 'rotate-icon-180' : ''}>
              <DropdownIcon
                className="icon-size-sm"
                color={getColorCode(themeColor)}
              />
            </div>
          </div>
          {openSections[index] && (
            <div data-testid={`accordion-panel-${index}`}>
              {section.component}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
